<div class="__center-group">
  <h1 class="__header">Floor Plan</h1>
  <p class="__desc">
    Easily locate and manage all devices throughout your space from the perspective of your project’s floor plan.
  </p>
  <button class="__button"
          (click)="onOpenEditor($event)">
    <span class="__button-wrapper">Get Started</span>
  </button>
</div>
<div class="__floor-plan-image"></div>
